
import { computed, defineComponent, ref } from 'vue';
import { ComponentName } from '@/products/api/configuration/components/ComponentName';
import { setupComponent } from '@/products/composables/setupComponent';

import InjectStyles from '@/common/components/InjectStyles.vue';
import AttributesTable from '@/common/components/AttributesTable.vue';
import { DataType } from '@/products/api/configuration/application/DataType';
import PrmList from '@/common/components/PrmList.vue';
import { PrmDataSetup, buildPrmAnchorId, setupPrmData } from '@/products/composables/prmData';

export default defineComponent({
  name: ComponentName.detailsAttributeGroups,

  components: {
    PrmList,
    InjectStyles,
    AttributesTable,
  },

  props: {
    instanceId: String,
  },

  setup(props) {
    const root = ref<HTMLElement>();

    const { instance, componentName, isReady, isWebComponent, store, t, emit } = setupComponent(
      root,
      props.instanceId,
      [DataType.AttributeGroups, DataType.ProductRelationships],
    );

    const hideDocumentLinks = computed(
      () => store.value?.options.components?.common?.hideDocumentLinks == true,
    );

    const prmData: PrmDataSetup = setupPrmData(instance);

    const prmDataFiltered = prmData.visibleAgmData;

    const productId = computed(() => store.value?.data.productDetail?.item?.productId);

    return {
      root,
      componentName,
      isReady,
      isWebComponent,
      store,
      instance,
      hideDocumentLinks,
      prmDataFiltered,
      productId,
      t,
      emit,
      buildPrmAnchorId,
    };
  },
});
